import { render } from "./PaymentHeader.vue?vue&type=template&id=b976ead0"
import script from "./PaymentHeader.vue?vue&type=script&lang=js"
export * from "./PaymentHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__